import React, { useState, useEffect } from 'react';
import styles from "./HomePageBanner.module.css";
import ImageWithFallback from '../ImageWithFallback';

const banners = [
    { id: 1, imageUrl: require("./../../assets/Home-page-banner.png")},
    { id: 2, imageUrl: require("./../../assets/Banner-2.jpg")}
];
export default function HomePageBanner() {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide === banners.length - 1 ? 0 : prevSlide + 1));
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.bannerContainer}>
            <div className={styles.slider} style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {banners.map((banner, index) => (
                    <div key={banner.id} className={styles.slide}>
                        <ImageWithFallback loading="lazy"
                            src={banner.imageUrl}
                            alt={`Banner ${banner.id}`}
                            className={styles.slideImage}
                        />
                    </div>
                ))}
            </div>
            <div className={styles.dotContainer}>
                {banners.map((banner, index) => (
                    <span key={banner.id} className={`${styles.dot} ${index === currentSlide ? styles.active : ''}`}></span>
                ))}
            </div>
        </div>
    );
}